import ModalAdjuntarArchivos from './ModalAdjuntarArchivos';

export default ModalAdjuntarArchivos;
